import { render } from "./Page401.vue?vue&type=template&id=e8e87284"
import script from "./Page401.vue?vue&type=script&lang=js"
export * from "./Page401.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\raubart\\Desktop\\loop\\hyundai_shop\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__